<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { sizerem } from './config/rem.conf.js'
export default {
  name: 'App',
  created() {
    sizerem(document, window);
    window.onresize = () => {
      sizerem(document, window);
    };
    // const nav = sessionStorage.getItem('activeNav')
    // if(!nav) {
    //   this.$router.replace('/index')
    // }
  },
  beforeCreate(){
    let count = 0;
    let imgs = [
      require('./assets/image/phone2.png'),require('./assets/image/intru1.jpg'),require('./assets/image/tech/1_0000.jpg'),
      require('./assets/image/tech/1_0001.jpg'),require('./assets/image/tech/1_0002.jpg'),require('./assets/image/tech/1_0003.jpg'),
      require('./assets/image/tech/1_0004.jpg'),require('./assets/image/tech/1_0005.jpg'),require('./assets/image/tech/1_0006.jpg'),
      require('./assets/image/tech/1_0007.jpg'),require('./assets/image/tech/1_0008.jpg'),require('./assets/image/tech/1_0009.jpg'),
      require('./assets/image/tech/1_0010.jpg'),require('./assets/image/tech/1_0011.jpg'),require('./assets/image/tech/1_0012.jpg'),
      require('./assets/image/tech/1_0013.jpg'),require('./assets/image/tech/1_0014.jpg'),require('./assets/image/tech/1_0015.jpg'),
      require('./assets/image/tech/1_0016.jpg'),require('./assets/image/tech/1_0017.jpg'),require('./assets/image/tech/1_0018.jpg'),
      require('./assets/image/tech/1_0019.jpg'),require('./assets/image/tech/1_0020.jpg'),require('./assets/image/tech/1_0021.jpg'),
      require('./assets/image/tech/1_0022.jpg'),require('./assets/image/tech/1_0023.jpg'),require('./assets/image/tech/1_0024.jpg'),
      require('./assets/image/tech/1_0025.jpg'),require('./assets/image/tech/1_0026.jpg'),require('./assets/image/tech/1_0027.jpg'),
      require('./assets/image/tech/1_0028.jpg'),require('./assets/image/tech/1_0029.jpg'),require('./assets/image/tech/1_0030.jpg'),
      require('./assets/image/tech/1_0031.jpg'),require('./assets/image/tech/1_0032.jpg'),require('./assets/image/tech/1_0033.jpg'),
      require('./assets/image/tech/1_0034.jpg'),require('./assets/image/tech/1_0035.jpg'),require('./assets/image/tech/1_0036.jpg'),
      require('./assets/image/tech/1_0037.jpg'),require('./assets/image/tech/1_0038.jpg'),require('./assets/image/tech/1_0039.jpg'),
      require('./assets/image/tech/1_0040.jpg'),require('./assets/image/tech/1_0041.jpg'),require('./assets/image/tech/1_0042.jpg'),
      require('./assets/image/tech/1_0043.jpg'),require('./assets/image/tech/1_0044.jpg'),require('./assets/image/tech/1_0045.jpg'),
      require('./assets/image/tech/1_0046.jpg'),require('./assets/image/tech/1_0047.jpg'),require('./assets/image/tech/1_0048.jpg'),
      require('./assets/image/tech/1_0049.jpg'),require('./assets/image/tech/1_0050.jpg'),
      require('./assets/image/intru/C4D0001.jpg'),require('./assets/image/intru/C4D0002.jpg'),require('./assets/image/intru/C4D0003.jpg'),
      require('./assets/image/intru/C4D0004.jpg'),require('./assets/image/intru/C4D0005.jpg'),require('./assets/image/intru/C4D0006.jpg'),
      require('./assets/image/intru/C4D0007.jpg'),require('./assets/image/intru/C4D0008.jpg'),require('./assets/image/intru/C4D0009.jpg'),
      require('./assets/image/intru/C4D0010.jpg'),require('./assets/image/intru/C4D0011.jpg'),require('./assets/image/intru/C4D0012.jpg'),
      require('./assets/image/intru/C4D0013.jpg'),require('./assets/image/intru/C4D0014.jpg'),require('./assets/image/intru/C4D0015.jpg'),
      require('./assets/image/intru/C4D0016.jpg'),require('./assets/image/intru/C4D0017.jpg'),require('./assets/image/intru/C4D0018.jpg'),
      require('./assets/image/intru/C4D0019.jpg'),require('./assets/image/intru/C4D0020.jpg'),require('./assets/image/intru/C4D0021.jpg'),
      require('./assets/image/intru/C4D0022.jpg'),require('./assets/image/intru/C4D0023.jpg'),require('./assets/image/intru/C4D0024.jpg'),
      require('./assets/image/intru/C4D0025.jpg'),require('./assets/image/intru/C4D0026.jpg'),require('./assets/image/intru/C4D0027.jpg'),
      require('./assets/image/intru/C4D0028.jpg'),require('./assets/image/intru/C4D0029.jpg'),require('./assets/image/intru/C4D0030.jpg'),
      require('./assets/image/intru/C4D0031.jpg'),require('./assets/image/intru/C4D0032.jpg'),require('./assets/image/intru/C4D0033.jpg'),
      require('./assets/image/intru/C4D0034.jpg'),require('./assets/image/intru/C4D0035.jpg'),require('./assets/image/intru/C4D0036.jpg'),
      require('./assets/image/intru/C4D0037.jpg'),require('./assets/image/intru/C4D0038.jpg'),require('./assets/image/intru/C4D0039.jpg'),
      require('./assets/image/intru/C4D0040.jpg'),require('./assets/image/intru/C4D0041.jpg')
    ]
    for (let img of imgs) {
      let image = new Image();
      image.onload = () => {
        count++;
      };
      image.src = img;
    }
  }
}
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  /* min-width: 1600px; */
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue